import { useQuery } from "react-query";
import * as municipalHelpService from "api/services/municipalHelpService";
import { oneDayInMs } from "constants/caching";

const {
  getAllHelpTitles,
  getAllFaqTitles,
  getHelpById,
  getFaqById,
} = municipalHelpService;

const oneDayCacheSetting = {
  cacheTime: oneDayInMs,
  staleTime: oneDayInMs,
  refetchOnMount: true,
};

// Help Queries
export const useHelpTitles = () =>
  useQuery(["help"], () => getAllHelpTitles(), oneDayCacheSetting);

export const useHelpContent = (helpId) =>
  useQuery(["help", helpId], () => getHelpById(helpId), oneDayCacheSetting);

// FAQ Queries
// Integration TODO: add a searchstring param to the FAQ questions query; the search box generates the param
export const useFaqQuestions = (searchString) =>
  useQuery(
    ["faqs", { searchString }],
    () => getAllFaqTitles(searchString),
    oneDayCacheSetting
  );

export const useFaqAnswer = (faqId) =>
  useQuery(["faqs", faqId], () => getFaqById(faqId), oneDayCacheSetting);
